import { render, staticRenderFns } from "./InventoriesMarketAreasDialog.vue?vue&type=template&id=06baed58&"
import script from "./InventoriesMarketAreasDialog.vue?vue&type=script&lang=ts&"
export * from "./InventoriesMarketAreasDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports